module.exports = `fragment text on Contentstack_text {
    text_body
    text_color_options
    text_heading
    text_wrapper_class
    text_wrapper_id
    icon_text {
      url
    }
  }`;